import { Locale } from '__generated__/EditorJsField_data.graphql';
import { TranslatableField } from './useTranslatableField';

type TranslationInput = {
  locale: Locale;
  string: string | null;
};

type TextTranslationInput = {
  translations: TranslationInput[];
};

export function makeTranslatableInput(field: TranslatableField) {
  const input: TextTranslationInput = {
    translations: [],
  };

  for (let locale in field) {
    input.translations.push({
      locale: locale as Locale,
      string: field[locale],
    });
  }

  return input;
}
